angular.module('leanlaw').directive('llEntryTable', ['userService', function (userService) {
  return {
    restrict: 'EA',
    template: require('./views/entry-table.html'),
    scope: {
      matter: '=',
      client: '=',
      entries: '=',
      includeWritedown: '='
    },
    controller: ['$scope', function ($scope) {
      // Initialize getEntryState with a default value
      $scope.getEntryState = function () {
        return '.entry'; // Default route
      };
      userService.me().then(me => {
        $scope.me = me;
        $scope.customFlagLabel = me.company.settings.labels && me.company.settings.labels.customFlag;

        // Update getEntryState after me() resolves
        $scope.getEntryState = function () {
          return (me.features?.timeEntriesTab ?? false) && (me.settings?.enableNewTimeEntry ?? false) ? '.entry2' : '.entry';
        };
      });
      $scope.$watch('matter', function (matter) {
        if (!matter) return;
        $scope.codes = matter.client.codes && matter.client.codes.ledes;
      });
      $scope.$watch('client', function (client) {
        if (!client) return;
        $scope.codes = client.codes && client.codes.ledes;
      });
    }]
  };
}]);